const companyServer = 'https://api-company.dev.fabrika-arraun.diversius.com/';

export const environment = {
  production: false,
  toasterTimeout: 6000,
  companyAdmin: {
    apiUrl: `${ companyServer }v1/`,
  }
};
